import { ChargeZemFail } from '../../../components/service/accounts/charge/ChargeZemFail';
export const ChargeFailPageView = () => {
  return <ChargeZemFail data-sentry-element="ChargeZemFail" data-sentry-component="ChargeFailPageView" data-sentry-source-file="fail.tsx" />;
};